module.exports = __webpack_public_path__ + "img/16.100e2a6d.png";